import React from "react";

const EditIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="EditFilled">
        <path
          id="Vector"
          d="M2.99902 17.2525V21.0025H6.74902L17.809 9.9425L14.059 6.1925L2.99902 17.2525ZM20.709 7.0425C21.099 6.6525 21.099 6.0225 20.709 5.6325L18.369 3.2925C17.979 2.9025 17.349 2.9025 16.959 3.2925L15.129 5.1225L18.879 8.8725L20.709 7.0425Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default EditIcon;
